import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=65688abd&scoped=true&"
import script from "./Zone.vue?vue&type=script&lang=js&"
export * from "./Zone.vue?vue&type=script&lang=js&"
import style0 from "./Zone.vue?vue&type=style&index=0&id=65688abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65688abd",
  null
  
)

export default component.exports